import { PLATFORMS } from '../constants';

const { ACCOUNTS } = PLATFORMS;

export const ACCOUNT_SETTINGS_LINK = `${ACCOUNTS}/dashboard/profile/`;
export const PRACTICE_SETTINGS_LINK = `${ACCOUNTS}/dashboard/practices/`;
export const LAB_SETTINGS_LINK = `${ACCOUNTS}/dashboard/labs/`;
